export default "__VITE_ASSET__C$d_RxKH__"